module.exports = __webpack_public_path__ + "static/media/0021.0aba12bd.jpg";